import { useMutation } from '@apollo/client';
import { useButtonMenu, useCustomSnackbar } from '@procureai/ui-mui';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useCockpitContext } from '../CockpitContextProvider/CockpitContextProvider.hook';
import { removeFromCockpitListQueryCache } from '../CockpitPanel/components/ThreadList/ThreadList.helper';
import { INTAKE_DISCARD_MUTATION } from '~/hooks/useIntakeRequestActions/useIntakeRequestActions.mutation.gql';
import { RouteId } from '~/routes/RouteId';

export const useCockpitPageHeader = () => {
  const { menuProps, buttonProps } = useButtonMenu();
  const { closeThread, threadId } = useCockpitContext();
  const { onError } = useCustomSnackbar();
  const location = useLocation();

  const [deleteChatSession, { loading: isLoading, client }] = useMutation(INTAKE_DISCARD_MUTATION, {
    variables: {
      data: {
        id: threadId,
      },
    },
    onError,
  });

  const deleteTask = useCallback(async () => {
    const { data } = await deleteChatSession();
    const chatSessionId = data?.sevenbridges.chatSession.discard.id;
    if (chatSessionId) {
      removeFromCockpitListQueryCache(client.cache, chatSessionId);
    }
    closeThread();
    // This method never needs recalculation as cached entities are retrieved on the fly anyway
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    isDetailPage: location.pathname !== RouteId.cockpit,
    newTask: closeThread,
    deleteTask,
    isLoading,
    menuProps,
    buttonProps,
  };
};
